'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tree = require('antd/lib/tree');

var _tree2 = _interopRequireDefault(_tree);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('antd/lib/tree/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TreeNode = _tree2.default.TreeNode;

var TreeWidget = function (_Component) {
  _inherits(TreeWidget, _Component);

  function TreeWidget(props) {
    _classCallCheck(this, TreeWidget);

    var _this = _possibleConstructorReturn(this, (TreeWidget.__proto__ || Object.getPrototypeOf(TreeWidget)).call(this, props));

    _this.onCheck = function (checkedKeys, e) {
      _this.props.onChange(checkedKeys);

      var toExpand = [];
      e.checkedNodes.forEach(function (entry) {
        if (entry.props.children && entry.props.children.length) {
          toExpand.push(entry.key);
        }
      });

      var tempData = [].concat(_toConsumableArray(_this.state.expanded), toExpand);
      var unique = [].concat(_toConsumableArray(new Set(tempData)));
      _this.onExpand(unique, { node: e.node, expanded: true });
    };

    _this.onExpand = function (expandedKeys, e) {
      if (e.expanded) {
        _this.setState({ expanded: expandedKeys });
      } else {
        var recursive = function recursive(object, array) {
          array.push(object.key);

          if (!object.children || !object.children.length) {
            return array;
          }

          object.children.forEach(function (entry) {
            array = array.concat(recursive(entry, []));
          });
          return array;
        };

        var childrens = [];
        childrens = recursive(e.node.props.dataRef, []);

        var toExpand = [];

        expandedKeys.forEach(function (entry) {
          if (childrens.indexOf(entry) === -1) {
            toExpand.push(entry);
          }
        });

        console.log('chi', toExpand, childrens);

        _this.setState({ expanded: toExpand });
      }
    };

    _this.renderTreeNodes = function (data) {
      return data.map(function (item) {
        if (item.children) {
          return _react2.default.createElement(
            TreeNode,
            { title: item.title, key: item.key, dataRef: item, selectable: false },
            _this.renderTreeNodes(item.children)
          );
        }
        return _react2.default.createElement(TreeNode, Object.assign({ dataRef: item, selectable: false }, item));
      });
    };

    _this.state = {
      expanded: []
    };
    return _this;
  }

  _createClass(TreeWidget, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _tree2.default,
        {
          checkable: true,
          multiple: true,
          expandedKeys: this.state.expanded,
          checkedKeys: this.props.value,
          onCheck: this.onCheck,
          onExpand: this.onExpand
        },
        this.renderTreeNodes(this.props.schema.options)
      );
    }
  }]);

  return TreeWidget;
}(_react.Component);

TreeWidget.defaultProps = {
  value: []
};

TreeWidget.propTypes = {
  value: _propTypes2.default.array,
  onChange: _propTypes2.default.func.isRequired,
  schema: _propTypes2.default.shape({
    options: _propTypes2.default.array
  }).isRequired
};

exports.default = TreeWidget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/Widgets/TreeWidget/index.js
// module id = 1017
// module chunks = 0